export default "__VITE_ASSET__xSHqf7VU__"